import barba from '@barba/core';

export const video = () => {

	var videos = document.querySelectorAll('video');

	function isInViewport(element) {
		var rect = element.getBoundingClientRect();
		var html = document.documentElement;
		return (
			rect.top >= (rect.top - rect.bottom) &&
			rect.top <= (window.innerHeight || html.clientHeight)
		);
	}

	function playPauseVideos(elements) {
		if(elements.length > 0){
			for (var i = 0; i < elements.length; i++) {
				if(isInViewport(elements[i])){
					elements[i].play();
				} 
				else if (!isInViewport(elements[i])){
					elements[i].pause();
				}
			}
		}
	}

	addEventListener("scroll", (e) => {
		playPauseVideos(videos);
	});
	
	barba.hooks.enter((data) => {
		var nextHtml = data.next.container;
    	videos = nextHtml.querySelectorAll('video');
    	playPauseVideos(videos);
    });

    barba.hooks.once((data) => {
		var nextHtml = data.next.container;
    	videos = nextHtml.querySelectorAll('video');
    	playPauseVideos(videos);
    });

}